import { render, staticRenderFns } from "./UserCollect.vue?vue&type=template&id=6fa90c09&scoped=true&"
import script from "./UserCollect.vue?vue&type=script&lang=js&"
export * from "./UserCollect.vue?vue&type=script&lang=js&"
import style0 from "./UserCollect.vue?vue&type=style&index=0&id=6fa90c09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa90c09",
  null
  
)

export default component.exports